import { render } from "./ModalAdminCrypto.vue?vue&type=template&id=6f5477a6&scoped=true"
import script from "./ModalAdminCrypto.vue?vue&type=script&lang=js"
export * from "./ModalAdminCrypto.vue?vue&type=script&lang=js"

import "./ModalAdminCrypto.vue?vue&type=style&index=0&id=6f5477a6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f5477a6"]])

export default __exports__